import { AccessAwareConvexClient } from "./access-aware-convex-client";

const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

// In development, allow running without Convex URL for UI development
// The app will show connection errors in the console but won't crash
if (!convexUrl && import.meta.env.PROD) {
  throw new Error(
    "Missing VITE_CONVEX_URL environment variable. " +
      "Please set it in your .env.local file or environment."
  );
}

// Use a placeholder URL in development if not set
// This allows UI development without a running Convex backend
export const convex = new AccessAwareConvexClient(
  convexUrl || "https://placeholder.convex.cloud"
);
